module.exports = __webpack_public_path__ + "media/images/athletes/527-de53e7234108f60dcbb5f0b2a829a504.png";